import { useQuery } from '@hooks/reactQuery';

import { getNetworkElementsMiddleware } from '@api/networkElements';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedBySystemId } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENTS_MIDDLEWARE_OPTIONS } from '@constants/queryKeys';

interface IUseQueryNetworkElementsMiddlewareParams {
	vendor: string;
}

interface IUseQueryNetworkElementsMiddlewareReturned {
	middlewareOptions: TSelectOption[];
	isLoadingMiddlewareOptions: boolean;
}

const useQueryNetworkElementsMiddleware
	= (params?: IUseQueryNetworkElementsMiddlewareParams): IUseQueryNetworkElementsMiddlewareReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [NETWORK_ELEMENTS_MIDDLEWARE_OPTIONS, params],
		select: (data) => optionsFormattedBySystemId(data),
		queryFn: extractQueryParams(getNetworkElementsMiddleware),
		...refetchOptions,
	});

	return {
		middlewareOptions: data || [],
		isLoadingMiddlewareOptions: (isLoading && !!data)
			|| isFetching,
	};
};

export default useQueryNetworkElementsMiddleware;
